import React, { useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { loading } from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import { Btn, Reveal } from "../components/ui.js";
import { findService } from "../data/services.js";

/* ============================================================
   LEVELUP ONE — Service Detail (/services/:cat/:item)
   ============================================================ */

const check = (
  <span style={{ width: 26, height: 26, flex: "0 0 auto", display: "grid", placeItems: "center", borderRadius: 8, background: "var(--nx-grad-soft)", color: "var(--nx-primary)", fontSize: "0.85rem" }}>✓</span>
);

export default function ServiceDetail() {
  const { cat: catSlug, item: itemSlug } = useParams();
  const navigate = useNavigate();
  const found = findService(catSlug, itemSlug);

  useEffect(() => {
    loading(false);
    window.scrollTo(0, 0);
  }, [catSlug, itemSlug]);

  if (!found) {
    return (
      <div className="nx">
        <Navbar />
        <div className="container nx-404">
          <div>
            <div className="nx-404__code nx-gradient-text">ไม่พบบริการ</div>
            <p className="nx-muted mb-4">ไม่พบบริการที่คุณกำลังค้นหา</p>
            <Btn onClick={() => navigate("/services")}>กลับไปหน้าบริการ</Btn>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  const { cat, item } = found;
  const others = cat.items.filter((i) => i.slug !== item.slug);

  return (
    <div className="nx">
      <Navbar />

      {/* ===== HERO ===== */}
      <section className="nx-section" style={{ paddingTop: 130 }}>
        <div className="container">
          <Reveal>
            <div className="nx-breadcrumb">
              <Link to="/">หน้าหลัก</Link> &nbsp;/&nbsp;
              <Link to="/services"> บริการ</Link> &nbsp;/&nbsp;
              <Link to={`/services#${cat.id}`}> {cat.name}</Link> &nbsp;/&nbsp;
              <span> {item.title}</span>
            </div>

            <span className="nx-eyebrow mt-3"><span aria-hidden="true">{cat.ico}</span> {cat.name}</span>
            <h1 className="nx-ink mt-3" style={{ fontSize: "clamp(2.2rem, 5vw, 3.4rem)" }}>{item.title}</h1>
            <p className="nx-primary fw-bold mt-2" style={{ fontSize: "1.1rem" }}>{item.lead}</p>
            <p className="nx-subtitle mt-2">{cat.feature.desc}</p>

            <div className="d-flex flex-wrap gap-3 mt-4">
              <Btn to="/booking">นัดคุย Founder 30 นาที</Btn>
              <Btn to={`/services#${cat.id}`} variant="ghost">ดูบริการอื่นในหมวด {cat.name} →</Btn>
            </div>
          </Reveal>

          {/* highlights card */}
          <Reveal delay={120}>
            <div className="nx-card mt-5" style={{ maxWidth: 820 }}>
              <span className="nx-eyebrow">จุดเด่นของบริการ</span>
              <h3 className="nx-card__title mt-3">{item.desc}</h3>
              <ul style={{ listStyle: "none", padding: 0, margin: "18px 0 0", display: "grid", gap: 12 }}>
                {(item.points || []).map((p) => (
                  <li key={p} style={{ display: "flex", gap: 10, alignItems: "center", color: "var(--nx-ink)", fontWeight: 500 }}>
                    {check}{p}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </section>

      {/* ===== OTHER ITEMS IN CATEGORY ===== */}
      <section className="nx-section nx-bg-surface">
        <div className="container">
          <Reveal>
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-4">
              <h2 className="nx-heading m-0" style={{ fontSize: "1.5rem" }}>บริการอื่นในหมวด {cat.name}</h2>
              <span className="nx-muted" style={{ letterSpacing: "0.1em" }}>{String(others.length).padStart(2, "0")}</span>
            </div>
          </Reveal>
          <div className="row g-3">
            {others.map((it, i) => (
              <div className="col-12 col-md-6 col-lg-4" key={it.slug}>
                <Reveal delay={i * 50}>
                  <Link to={`/services/${cat.id}/${it.slug}`} className="nx-subcard d-block">
                    <div className="nx-subcard__head">
                      <span className="nx-subcard__ico" aria-hidden="true">{it.ico}</span>
                      <span className="nx-subcard__title">{it.title}</span>
                    </div>
                    <p className="nx-subcard__desc">{it.desc}</p>
                    <span className="nx-subcard__link">ดูเพิ่มเติม →</span>
                  </Link>
                </Reveal>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== TAGLINE ===== */}
      <section className="nx-section--tight nx-bg-soft">
        <div className="container">
          <Reveal>
            <div className="nx-tagline">
              <h2 className="nx-tagline__title">สร้างจากไทย — <span className="nx-gradient-text">ส่งมอบทั่วโลก</span></h2>
              <div className="nx-tagline__card">
                <span className="nx-eyebrow">เริ่มโปรเจกต์กับเรา</span>
                <p className="nx-card__desc my-3">คุยฟรี 30 นาที ไม่มีข้อผูกมัด แล้วเราจะช่วยประเมินแนวทางให้</p>
                <Btn to="/booking" block>พูดคุยกับเรา</Btn>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <Footer />
    </div>
  );
}
